import React from 'react'
import Header from '../../../layouts/doctor/DoctorHeader'

import { Auditlogs } from './Auditlogs';
import { useSelector } from 'react-redux';
import { selectLoc } from '../../../redux/slice/locSlice';
import { createAuditLogs } from '../../../api/providerApi/providerApi';
import useHeaders from '../../../helpers/useHeaders';
import path from '../../../path';
import useEncryption from '../../../services/useEncryption';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { Notificationlogs } from './NotificationLogs';
import { selectAuth } from '../../../redux/slice/authSlice';
import { exportNotificationsCsvApi } from '../../../api/userApi/userApi';


export const Notifications = () => {

  const [value, setValue] = React.useState('1');
  const [search, setSearch] = React.useState("");
  const { selectedLogs } = useSelector(selectLoc);
  const headers = useHeaders();
  const { encryptData, decryptData } = useEncryption();
  const { id } = useParams();
  let decryptId = decryptData(id);
  const { role } = useSelector(selectAuth);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const downloadCSVFile = async () => {
    try {
      if (selectedLogs.length == 0) {
        toast.error("Please select some records to export in CSV File.");
        return
      }
      const encrypted = encryptData(selectedLogs);
      const response = await exportNotificationsCsvApi(encrypted, role);
      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'notifications.csv');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      let obj = {
        event: 'Doctor has download the CSV file for Logs.'
      }
      await createAuditLogs({ data: encryptData(obj) }, headers);
    } catch (error) {
      console.error('Error downloading notification logs CSV:', error);
    }
  };

  return (
    <div>
      <Header pageTitle="Notification Details" />
      <div className="cardOuter">
        <div className="cardheads">
          {/* <div className="cardTitle">Notification Details</div> */}
          {/* <button className="btn blackoutlineBtn">Refresh</button> */}
        </div>
        <div className="cardcontents">
          <div className="topsearchs">
            <div className="d-flex align-items-center justify-content-between">
              <div className="searchBar">
                <input
                  type="text"
                  autoComplete="off"
                  placeholder="Search"
                  value={search}
                  onChange={(event) => setSearch(event.target.value)}
                />
              </div>
              <button className="btn blackoutlineBtn" onClick={downloadCSVFile}>
                Download CSV
              </button>
            </div>
            <Notificationlogs type="audit" search={search} />
          </div>
        </div>
      </div>
    </div>

  )
}
